import { render, staticRenderFns } from "./ResultCounter.vue?vue&type=template&id=368649a5&scoped=true&"
import script from "./ResultCounter.vue?vue&type=script&lang=js&"
export * from "./ResultCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368649a5",
  null
  
)

export default component.exports